import { Form, Formik } from 'formik'
import React, { Component } from 'react'
import styled from 'styled-components'
import { FakePasswordInput } from '../../../../../components/form-components/inputs.component'
import Yup from './../../../../../helpers/custom-yup'

const getSchema = (isEdit) => {
	let password = Yup.string().password()

	let passwordConfirmation = Yup.string()

	if (!isEdit) {
		password = password.required('Informe a senha')
		passwordConfirmation = passwordConfirmation
			.equalTo(Yup.ref('password'), 'As senhas digitadas não conferem')
			.required('Informe a confirmação da nova senha')
	} else {
		passwordConfirmation = passwordConfirmation.equalToRequired(
			Yup.ref('password'),
			'As senhas digitadas não conferem'
		)
	}

	return Yup.object().shape({
		password,
		passwordConfirmation,
		securityKey: Yup.string()
			.securityKey()
			.required('Informe a chave de segurança'),
	})
}

const StyledForm = styled.div`
	padding: 1rem 0 2.4rem;
	max-width: 300px;
`

const StyledInputContainer = styled.div`
	margin-top: 4rem;
`

class PasswordFormComponent extends Component {
	constructor(props) {
		super(props)
		this.passwordRef = React.createRef()
		this.passwordConfirmationRef = React.createRef()
		this.securityKeyRef = React.createRef()
	}

	submit() {
		this.refs.form.submitForm()
		setTimeout(() => {
			const errors = this.refs.form.state.errors
			if (errors && Object.keys(errors).length) {
				const id = Object.keys(errors)[0]
				const ref = this[`${id}Ref`]
				if (!ref || !ref.current) return
				ref.current.focus()
			}
		}, 0)
	}

	render() {
		const { initialValues, onSubmit, isEdit } = this.props
		return (
			<Formik
				ref="form"
				initialValues={initialValues}
				onSubmit={(values) => {
					onSubmit && onSubmit(values)
				}}
				validationSchema={getSchema(isEdit)}
				render={(props) => (
					<Form noValidate>
						<p className="static-information">
							A sua senha deve ter no mínimo 12 caracteres e conter pelo
							menos uma letra maiúscula, uma letra minúscula, 1 número e
							1 caractere especial
						</p>
						<br />
						<br />
						<StyledForm>
							<FakePasswordInput
								elementRef={this.passwordRef}
								id="password"
								label={`Senha ${!isEdit ? '*' : ''}`}
								maxLength={256}
								{...props}
							/>
							<StyledInputContainer>
								<FakePasswordInput
									elementRef={this.passwordConfirmationRef}
									id="passwordConfirmation"
									label={`Redigite a senha ${!isEdit ? '*' : ''}`}
									maxLength={256}
									{...props}
								/>
							</StyledInputContainer>
							<StyledInputContainer>
								<FakePasswordInput
									elementRef={this.securityKeyRef}
									id="securityKey"
									label="Chave de segurança *"
									maxLength={4}
									{...props}
								/>
							</StyledInputContainer>
						</StyledForm>
					</Form>
				)}
			/>
		)
	}
}

export default PasswordFormComponent
